import { Sidebar, Navbar } from "flowbite-react";
import {
  HiBookOpen,
  HiCog,
  HiNewspaper,
  HiUser,
  HiCube,
  HiCursorClick,
  HiDocument,
  HiLogout,
} from "react-icons/hi";
import { Outlet, useNavigate } from "react-router-dom";
import { routes } from "../routes";
import { useAuth } from "../context/authContext";

const MainRoute = () => {
  const { logout, permissions } = useAuth();
  const navigate = useNavigate();
  const handleClickItem = (route: string) =>
    navigate(`${routes.DASHBOARD}/${route}`);

  const viewNotes = permissions.find((item) => item.slug === "ver-notas");
  const viewAuthors = permissions.find((item) => item.slug === "ver-autores");
  const viewNewspaper = permissions.find(
    (item) => item.slug === "ver-edicion-impresa"
  );
  const viewAds = permissions.find((item) => item.slug === "ver-publicidad");
  const viewPages = permissions.find(
    (item) => item.slug === "ver-paginas-estaticas"
  );
  const viewHeaders = permissions.find((item) => item.slug === "ver-cabeceras");
  const viewUsers = permissions.find((item) => item.slug === "ver-usuarios");
  const viewSettings = permissions.find((item) => item.slug === "ver-ajustes");

  const onLogout = () => logout();

  return (
    <>
      <Navbar
        fluid
        className="fixed z-30 w-full bg-white border-b border-gray-200 dark:bg-gray-800 dark:border-gray-700"
      >
        <Navbar.Brand>
          <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">
            Monclova | Dashboard
          </span>
        </Navbar.Brand>
      </Navbar>
      <div className="flex items-start pt-1 flex-1">
        <Sidebar
          theme={{
            root: {
              base: "bg-white",
              inner: "bg-white px-3",
            },
          }}
          className="flex h-full flex-col justify-between fixed top-0 left-0 z-20 flex flex-col flex-shrink-0 hidden w-64 h-full pt-16 font-normal duration-75 lg:flex transition-width bg-white border-r border-gray-200 dark:bg-gray-800 dark:border-gray-700"
        >
          <Sidebar.Items>
            <Sidebar.ItemGroup>
              {viewNotes && (
                <Sidebar.Item
                  onClick={() => handleClickItem(routes.NOTES)}
                  href="#"
                  icon={HiNewspaper}
                >
                  Noticias
                </Sidebar.Item>
              )}
              {viewAuthors && (
                <Sidebar.Item
                  onClick={() => handleClickItem(routes.AUTHORS)}
                  href="#"
                  icon={HiCog}
                >
                  Autores
                </Sidebar.Item>
              )}
              {viewNewspaper && (
                <Sidebar.Item
                  onClick={() => handleClickItem(routes.MAGAZINES)}
                  href="#"
                  icon={HiBookOpen}
                >
                  Edición impresa
                </Sidebar.Item>
              )}
              {viewAds && (
                <Sidebar.Collapse icon={HiCursorClick} label="Publicidad">
                  <Sidebar.Item
                    onClick={() => handleClickItem(routes.ADS)}
                    href="#"
                  >
                    Ver todos
                  </Sidebar.Item>
                  <Sidebar.Item
                    onClick={() => handleClickItem(routes.ADS_SECTIONS)}
                    href="#"
                  >
                    Secciones
                  </Sidebar.Item>
                  <Sidebar.Item
                    onClick={() => handleClickItem(routes.ADS_CAMPAIGN)}
                    href="#"
                  >
                    Campaña TXT
                  </Sidebar.Item>
                </Sidebar.Collapse>
              )}
              {viewPages && (
                <Sidebar.Item
                  onClick={() => handleClickItem(routes.PAGES)}
                  href="#"
                  icon={HiDocument}
                >
                  Páginas Estáticas
                </Sidebar.Item>
              )}
              {viewHeaders && (
                <Sidebar.Item
                  onClick={() => handleClickItem(routes.HEADERS)}
                  href="#"
                  icon={HiCube}
                >
                  Cabeceras
                </Sidebar.Item>
              )}
              {viewUsers && (
                <Sidebar.Collapse icon={HiUser} label="Usuarios">
                  <Sidebar.Item
                    onClick={() => handleClickItem(routes.USERS)}
                    href="#"
                  >
                    Ver todos
                  </Sidebar.Item>
                  <Sidebar.Item
                    onClick={() => handleClickItem(routes.PROFILES)}
                    href="#"
                  >
                    Perfiles
                  </Sidebar.Item>
                </Sidebar.Collapse>
              )}
              {viewSettings && (
                <Sidebar.Item
                  onClick={() => handleClickItem(routes.SETTINGS)}
                  href="#"
                  icon={HiCog}
                >
                  Ajustes
                </Sidebar.Item>
              )}
              <Sidebar.Item onClick={() => onLogout()} href="#" icon={HiLogout}>
                Cerrar sesión
              </Sidebar.Item>
            </Sidebar.ItemGroup>
          </Sidebar.Items>
        </Sidebar>

        <div
          className="fixed inset-0 z-10 hidden bg-gray-900/50 dark:bg-gray-900/90"
          id="sidebarBackdrop"
        ></div>
        <div className="relative w-full h-full overflow-y-auto bg-gray-50 lg:ml-64 pt-16 dark:bg-gray-900">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default MainRoute;
